import { render } from "./Validation_Documents.vue?vue&type=template&id=47d2aab4"
import script from "./Validation_Documents.vue?vue&type=script&lang=js"
export * from "./Validation_Documents.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__